// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetTextOutput, ObjectTypeV1 } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { TextForm, TextValues } from '@Organisms/Dashboard/WidgetManage/Text/TextForm';

export const getNewTextWidget = (text: TextValues): WidgetTextOutput => {
    const { title, template = '', series = [] } = text;

    return {
        type: WidgetChartTypeEnum.text,
        options: {
            title,
            query: {},
            template: template.trim(),
            series: series.map((serie) => ({ ...serie, name: serie.label })),
            entity: '' as ObjectTypeV1,
        },
        id: '',
    };
};

const NewTextDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewTextWidget(values as TextValues)}
        WidgetForm={TextForm}
        widgetType="text"
    />
);

export default NewTextDrawer;
